import React from 'react';
import { IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Typography, withStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

const styles = {
  languagesWrapper: {
    width: '100%',
  },
  languagesListTitle: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    padding: '16px',
  },
  languagesList: {
    paddingTop: 0,
  },
  languageItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '18px',
    '&&:hover': {
      backgroundColor: '#EDEDED',

    },
  },
  selected: {
    backgroundColor: '#EDEDED',
  },
  languageName: {
    flexGrow: 0,
    margin: 0,
    '&& > span': {
      fontSize: '16px',
      fontWeight: 400,
    },
  },
  languageCode: {
    flexGrow: 0,
    margin: '0 0 0 4px',
    padding: '0 12px',
    borderRadius: '4px',
    backgroundColor: '#F8F8F8',
    '&& > span': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
    },
  },
};

const LanguagesList = ({ classes, languages, hasDelete, onLanguagePick, chosenLanguage, onLanguageDelete }) => {
  return (
    <div className={classes.languagesWrapper}>
      <Typography className={classes.languagesListTitle}>Languages:</Typography>
      <List component="nav" className={classes.languagesList}>
        {languages.map(language =>
          <ListItem
            button
            key={language.id}
            onClick={() => chosenLanguage !== language.id && onLanguagePick(language)}
            className={`${classes.languageItem} ${chosenLanguage === language.id ? classes.selected : null}`}
          >
            <ListItemText primary={language.name} className={classes.languageName}/>
            <ListItemText primary={language.originId} className={classes.languageCode}/>
            {
              hasDelete ? <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => onLanguageDelete(language)}>
                  <DeleteIcon/>
                </IconButton>
              </ListItemSecondaryAction> : null
            }
          </ListItem>,
        )}
      </List>
    </div>
  );
};

export default withStyles(styles)(LanguagesList);
